import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2
} from '@angular/core';
import { ScrollSpyService } from '../_services/scroll-spy.service';

@Directive({
  selector: '[sdSpyOn]',
  standalone: true
})
export class SdSpyOnDirective implements OnInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private scrollSpyService: ScrollSpyService,
  ) {}
  private isActive = false;

  @Input()
  activeClass: string;

  @Input()
  sdSpyOn: string;

  @Output()
  isActivated = new EventEmitter<void>();

  ngOnInit() {
    this.scrollSpyService.activeSpyTarget.subscribe((targetName) => {
      if (!this.isActive && targetName === this.sdSpyOn) {
        this.setActive();
        this.isActivated.emit();
      } else if (this.isActive && targetName !== this.sdSpyOn) {
        this.setInactive();
      }
    });
  }

  setActive() {
    this.isActive = true;
    if (this.activeClass) {
      this.renderer.addClass(this.el.nativeElement, this.activeClass);
    }
  }

  setInactive() {
    this.isActive = false;
    if (this.activeClass) {
      this.renderer.removeClass(this.el.nativeElement, this.activeClass);
    }
  }
}
